import styled from 'styled-components'

const TitleCard = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  color: #303030;

  h3 {
    margin: 0px 0px 0px 4px;
  }
`
export default TitleCard
